module.exports = __webpack_public_path__ + "portal-static/img/excel.bd080193.png";